import { type } from 'arktype';
import { createPaginatedResponseSchema } from '../shared/pagination';

/** Contrato del catálogo `niche` (subcategoría con su propio color de ADN). */
export const nicheResponseSchema = type({
	categoryId: 'string.uuid',
	id: 'string.uuid',
	name: 'string',
	// Hex de seis dígitos con almohadilla, mismo patrón que `category.colorHex`.
	rgbAdnHex: /^#[0-9a-fA-F]{6}$/,
	slug: 'string',
}).onUndeclaredKey('delete');

export type NicheResponse = typeof nicheResponseSchema.infer;

export const createNicheSchema = type({
	categoryId: 'string.uuid',
	name: 'string',
	rgbAdnHex: /^#[0-9a-fA-F]{6}$/,
	slug: 'string',
}).onUndeclaredKey('delete');

export type CreateNiche = typeof createNicheSchema.infer;

export const updateNicheSchema = createNicheSchema.partial();

export type UpdateNiche = typeof updateNicheSchema.infer;

export const nichePaginatedResponseSchema = createPaginatedResponseSchema(nicheResponseSchema);

export type NichePaginatedResponse = typeof nichePaginatedResponseSchema.infer;
